import React from 'react';
import css from './TopServiceCard.module.css';
import { Link } from 'react-router-dom';

export default function TopServiceCard(props) {
  const { img, title, filter, gradient, count } = props;

  const backgroundStyle = gradient
    ? { background: gradient }
    : img
    ? {}
    : { background: 'linear-gradient(135deg, #1a4731 0%, #0d2818 100%)' };

  return (
    <Link
      className={css.base}
      style={backgroundStyle}
      to={'/s?pub_type-of-service=' + filter}
    >
      {img && !gradient && (
        <img className={css.image} alt="Top service" src={img} />
      )}
      {count != null && (
        <span className={css.countBadge}>{count} coaches</span>
      )}
      <p className={css.title}>{title}</p>
    </Link>
  );
}
